module.exports = __webpack_public_path__ + "static/img/SketchPng82e4bbae3bc8f75205db9f05a4b3a7979811b7c4d88c5eadcfeca82fd0ea6c6f.45d6bc32.png";